import { add, fromNumber, type MonetaryValue } from 'ezmoney';

import type { RequestAPI } from 'modules/requests/types';

import type {
  Bill,
  SchedulingProcess,
  VerificationOfPayee,
} from '../../models';

// a wire transfer in UK cannot be scheduled more than 30 days in advance, Adyen limitation
export const ukWireTransferSchedulingLimit = 30;

export type Type = 'expense' | 'invoice';

export type TransferId = string;

export interface Transfer {
  id: TransferId;
  amount: MonetaryValue;
  scheduledForDate: string;
  bill: Bill;
  paymentMethods: {
    wiretransfer: {
      active: boolean;
      reasons: {
        counterparty: string[];
      };
    };
  };
  verificationOfPayee?: VerificationOfPayee;
}

export interface TransferDetails extends Transfer {
  schedulingProcess: SchedulingProcess;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  timeline: any;
  request: RequestAPI;
}

export const sumTransfersAmount = (
  transfers: Transfer[],
  currency: string,
): MonetaryValue => {
  if (transfers.length === 0) {
    return fromNumber(0, currency, 2);
  }

  // filter cross currency out as it's added to total outgoing amount from quotes outgoing amount
  const transfersSameCurrency = transfers.filter(
    (transfer) => transfer?.amount?.currency === currency,
  );

  return transfersSameCurrency.reduce(
    (sum: MonetaryValue, transfer: Transfer): MonetaryValue => {
      return add(sum, transfer.amount);
    },
    fromNumber(0, transfersSameCurrency?.[0]?.amount?.currency || currency, 2),
  );
};
